/*
 * View for an item from the basicAdminList
 */

define([
  "marionette",
  "modules/shared/basicAdminItemModal/template/basicAdminItemTemplate.html",
  "modules/shared/basicAdminItemModal/template/readOnlyItemTemplate.html",
], function (Marionette, BasicAdminItemTemplate, ReadOnlyItemTemplate) {
  var BasicAdminItemModalView = {};

  BasicAdminItemModalView.basicAdminItemModalView = Marionette.ItemView.extend({
    initialize: function (options) {
      this.nameAttribute = options.nameAttribute;
      this.descriptionAttribute = options.descriptionAttribute;
      //use the read only template if the model is read only (assigned during model creation)
      if (this.model.readOnly) {
        this.template = ReadOnlyItemTemplate;
      } else {
        this.template = BasicAdminItemTemplate;
      }
      if (options.descriptionAttribute) {
        this.model.showDescription = true;
      }
    },
    serializeData: function () {
      const data = this.constructor.__super__.serializeData.apply(this, arguments);
      if (this.nameAttribute != "name") {
        data.name = data[this.nameAttribute];
      }
      if (this.descriptionAttribute != "description") {
        data.description = data[this.descriptionAttribute];
      }
      return data;
    },
    getDescriptionValue: function () {
      return this.$el.find("#adminItemDescription").val();
    },
    getNameValue: function () {
      return this.$el.find("#adminItemName").val();
    },
    showError: function (field, errorMessage) {
      this.$el
        .find("#error")
        .append('<h5 class="error-message">' + field + " : " + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    clearError: function () {
      this.$el.find("#error").html("");
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return BasicAdminItemModalView;
});
